import styled from 'styled-components'

export const ContainerInfo = styled.div`
  width: 100%;
  height: 100%;

  .conteudo {
    display: flex;
    flex-direction: column;
    padding: 10px;
    gap: 10px;
  }

  .inconsistencia {
    display: flex;
    padding: 10px;
    border: 2px solid #d9d9d9;
    border-radius: 10px;
    gap: 10px;
    align-items: center;
    cursor: pointer;
  }

  .inconsistencia * {
    cursor: inherit;
  }

  .inconsistencia:hover {
    transform: scale(1.05);
    transition: 0.5s;
    background-color: #fffeed;
    border: 2px solid #efc82d;
    color: #e0b507;

    .icone__arrow {
       background-color: #e0b507;
    }
  }

  .icone__arrow {
    padding: 6px;
    border-radius: 50%;
    background-color: #5da57d;
    color: white;
    font-size: 11px;
  }
`
